$(function() {
	var drEvent = $('.dropify').dropify({
		messages: {
			'default': 'Arraste e solte um arquivo aqui ou clique',
			'replace': 'Arrasete e solte ou clique para substituir',
			'remove':  'Remover',
			'error':   'Opa, aconteceu um erro.'
		}
	});

	drEvent.on('dropify.afterClear', function(event, element){
		$('#pic_delete').val(1);
	});
	$(".colorpicker").asColorPicker();
});